import { render } from "./deleted.vue?vue&type=template&id=0feb1d60"
import script from "./deleted.vue?vue&type=script&lang=js"
export * from "./deleted.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\deyi\\baobei_web2\\web2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__